import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleRight } from '@fortawesome/pro-regular-svg-icons';

export const Link = ({ text, url }) => (
  <a className="cornerstone-widget__external-link" href={url} target="_blank" rel="noopener noreferrer">
    {text}
    {" "}
    <FontAwesomeIcon style={{ fontSize: '13px' }} icon={faChevronDoubleRight} />
  </a>
);

Link.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export const Empty = ({ isEmpty, msg }) => {
  if (!isEmpty) {
    return null;
  }

  return <p style={{ fontSize: '16px', fontWeight: 'bold' }}>{msg}</p>
}

Empty.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
  msg: PropTypes.string
}

Empty.defaultProps = {
  msg: 'There are currently no items to display.'
}



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/components/text.js